import {
  AGE,
  AGES,
  MARITAL_STATUS,
  PARTNER_NAME,
  TAX_FILING_STATE,
  INCOME,
  EXPENSES,
  CHILDREN,
  CHILDREN_DETAILS,
  HOME_PURCHASE_VALUE,
  HOME_PURCHASE_YEAR,
  MORTGAGE,
  DOWN_PAYMENT,
  MORTGAGE_DETAILS,
  EARMARKED_ACCOUNTS,
  PROPERTY_TAX,
  HOMEOWNER_INSURANCE,
  HOA,
  HOA_DETAILS,
  PROPERTY_NAME,
} from '../SummaryConstants';

const DICTIONARY = {
  [MARITAL_STATUS]: {
    iterator: [1, 0],
    title: 'Partner',
  },
  [PARTNER_NAME]: {
    iterator: [1, 1],
    title: "Partner's Name",
  },
  [AGES]: {
    iterator: [1, 2],
    title: 'Ages',
  },
  [AGE]: {
    iterator: [1, 2],
    title: 'Age',
  },
  [CHILDREN]: {
    iterator: [1, 3],
    title: 'Children',
  },
  [CHILDREN_DETAILS]: {
    iterator: [1, 4],
    title: 'Children Details',
  },
  [TAX_FILING_STATE]: {
    iterator: [2, 0],
    title: 'Tax Filing State',
  },
  [INCOME]: {
    iterator: [3, 0],
    title: 'Income',
  },
  [EXPENSES]: {
    iterator: [4, 0],
    title: 'Expenses',
  },
  [PROPERTY_NAME]: {
    iterator: [5],
    title: 'Property name',
  },
  [HOME_PURCHASE_YEAR]: {
    iterator: [6],
    title: 'Purchase Year',
  },
  [HOME_PURCHASE_VALUE]: {
    iterator: [7],
    title: 'Home Value',
  },
  [MORTGAGE]: {
    iterator: [8, 0],
    title: 'Mortgage',
  },
  [DOWN_PAYMENT]: {
    iterator: [8, 1],
    title: 'Down Payment',
  },
  [MORTGAGE_DETAILS]: {
    iterator: [8, 2],
    title: 'Mortgage Details',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [9, 1],
    title: 'Earmarked Accounts',
  },
  [PROPERTY_TAX]: {
    iterator: [10],
    title: 'Property Tax',
  },
  [HOMEOWNER_INSURANCE]: {
    iterator: [11],
    title: "Homeowner's Insurance",
  },
  [HOA]: {
    iterator: [12],
    title: 'HOA',
  },
  [HOA_DETAILS]: {
    iterator: [13],
    title: 'HOA Details',
  },
};
export default DICTIONARY;
